var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.000244,
    height: 28,
    viewBox: "0 0 26.0002 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_12_247_dd",
    x: 0,
    y: 0,
    width: 26.000244,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect_innerShadow_1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "translate(13.0001 14) rotate(90) scale(14 13.0001)",
    cx: 0,
    cy: 0,
    r: 1,
    id: "paint_radial_12_247_0",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A03C"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_12_247_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 0L22.54 1.5L24 2.05L22.54 2.61L22 4.11L21.46 2.61L20 2.05L21.46 1.5L22 0ZM17.5 1.7L17.9 2.83L19 3.24L17.9 3.66L17.5 4.78L17.09 3.66L16 3.24L17.09 2.83L17.5 1.7ZM0 25.09L19.79 4.72L22.62 7.63L2.82 28L0 25.09ZM24.9 6.26L24.5 5.14L24.09 6.26L23 6.68L24.09 7.1L24.5 8.22L24.9 7.1L26 6.68L24.9 6.26ZM23 9.25L23.54 10.75L25 11.31L23.54 11.86L23 13.37L22.46 11.86L21 11.31L22.46 10.75L23 9.25Z",
    fill: "url(#paint_radial_12_247_0)",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLayers);
export default __webpack_public_path__ + "static/media/ico_layers.cc8d875abc2021b3a0cfdd238ee71b91.svg";
export { ForwardRef as ReactComponent };